import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Image,
  Typography,
} from "antd";

import { useNavigate } from "react-router-dom";

import moment from "moment";
import placeholder from '../../../assets/img/BUILDING_placeholder.svg';

const { Text } = Typography;

const PropertyCard = (props) => {
  const history = useNavigate();
  const [csvData, setCsvData] = useState([]);

  const { property } = props;

  const {
    buildingName,
    address,
    erpLaName,
    unitDataCount,
    occupied,
    vacant,
    propertyId,
    galleryImages,
  } = property;

  const csvLinkEl = useRef();

  const coverImageUrl =
    galleryImages?.find(
      (img) => String(img.position) === "1" && img.documentUrl,
    )?.documentUrl || placeholder;

  useEffect(() => {
    const data = [];
    if (csvData.length > 0) {
      csvData.map((value, key) => {
        data.push({
          case_id: value.case_id,
          type:
            value.CaseCategoryClassification[0]?.CaseCategory?.category_type,
          subtype:
            value.CaseCategorySecondaryClassification[0]?.CaseSubCategory
              ?.category_sub_type,
          tenant_name:
            value.CaseRoleTenant?.length > 0
              ? value.CaseRoleTenant[0]?.Party?.name
              : "",
          technician:
            value.CaseRoleTechnician?.length > 0
              ? value.CaseRoleTechnician[0]?.Party?.name
              : "",
          appartment: value.Asset.name,
          recuring: value.ChildCase[0]?.parent_id,
          description: value.description,
          date:
            (value.ticket_date ? value.ticket_date : "") +
            " " +
            (value.ticket_start_time
              ? moment(value.ticket_start_time, "hh:mm:ss").format("LT") +
              " to "
              : "") +
            (value.ticket_end_time
              ? moment(value.ticket_end_time, "hh:mm:ss").format("LT")
              : ""),
        });
      });
      setTimeout(() => {
        //@ts-ignore
        csvLinkEl?.current?.link.click();
      }, 300);
    }
  }, [csvData]);

  return (
    <Col title={'Click to View Detail'}>
    <Card  bordered={false} className="propcard" onClick={() => history(`/property-detail/${propertyId}`)} style={{cursor:'pointer'}}>
      <Row gutter={[8, 8]}>
        <Col   xs={24} xl={8} lg={24} className="imageCard">
          <Image
            preview={false}
            title={buildingName}
            style={{background:'#e9ecf5'}}
            height={120}
            placeholder={true}
            alt={buildingName || "Property"}
            src={coverImageUrl}
            fallback={placeholder}
          />
        </Col>
        
        <Col xs={24} xl={16} className="list_view_content">

          <Card
            style={{paddingBottom:'0px'}}
            bordered={false}
            title={buildingName}
            className="ag-nospace-head ag-nospace-body"
          >
            <Text className="lineHeight28 ag-default  mb-0" title={address?.addressLine2 +" "+ address?.addressLine1 + " " + address?.emirates }>
              <span className="prop_heading">City:</span> {address?.emirates}
            </Text>
        
            <Text className="lineHeight28 ag-default  mb-0" style={{ display: "block", overflow: "visible" }}>
              <span className="prop_heading">Property Admin:</span>{" "}
              {erpLaName?.trim() ? (
                erpLaName
              ) : (
                <span style={{ color: "red"}}>
                  Not set.{" "}
                </span>
              )}
            </Text>

            <Text className="lineHeight28 ag-default  mb-0">
              <span className="prop_heading">No. of Units:</span> {unitDataCount > 0 ? unitDataCount : 0 }
            </Text>

            
            <Text className="lineHeight28 ag-default  mb-0">
              <span className="prop_heading">Units Vacant:</span> {vacant > 0 ? vacant : 0}
            </Text>

            
            <Text className="lineHeight28 ag-default  mb-0">
              <span className="prop_heading">Units Occupied:</span> {occupied > 0 ? occupied : 0}
            </Text>
          </Card>
          
        
        </Col>
      </Row>

    </Card>
    </Col>

  );

};

export default PropertyCard;
